import NubeskLoader from "./NubeskLoader";

export default NubeskLoader;
